<template>
    <form @submit.prevent="submit" id="get_deposit_manually_form">
        <kt-form-section is_first>
            <kt-row>
                <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                        <kt-form-label for="from_date">
                            {{ $t('label.from_date') }}
                        </kt-form-label>
                        <button id="reset_from_date"
                                @click="clearFromDate"
                                type="button"
                                class=" btn btn-label-danger trash-btn"
                        >
                            <i class="la la-trash-o"></i>
                        </button>
                        <datePicker
                            format="YYYY-MM-DD HH:mm:ss"
                            display-format="dddd jDD jMMMM jYYYY HH:mm"
                            input-class="form-control"
                            id="from_date"
                            name="from_date"
                            v-model="form_data.from_date"
                            type="datetime"
                        />
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="3">
                    <kt-form-group>
                        <kt-form-label for="to_date">
                            {{ $t('label.to_date') }}
                        </kt-form-label>
                        <button id="reset_to_date"
                                @click="clearToDate"
                                type="button"
                                class=" btn btn-label-danger trash-btn"
                        >
                            <i class="la la-trash-o"></i>
                        </button>
                        <datePicker
                            format="YYYY-MM-DD HH:mm:ss"
                            display-format="dddd jDD jMMMM jYYYY HH:mm"
                            input-class="form-control"
                            id="to_date"
                            name="to_date"
                            v-model="form_data.to_date"
                            type="datetime"
                        />
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                        <kt-form-label for="bank">
                            {{ $t('label.bank') }}
                        </kt-form-label>
                        <kt-form-select
                            size="3"
                            id="bank"
                            class="form-control"
                            name="bank"
                            v-model="form_data.bank"
                        >
                            <option value="saman">
                                {{ $t('wallets.bank.saman') }}
                            </option>
                            <option value="saderat">
                                {{ $t('wallets.bank.saderat') }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>

        <kt-form-action class="mt-4">
            <kt-button
                class="btn-wide"
                size="md"
                variant="success"
                type="submit"
                v-bind:wide="true"
                id="get_deposit_manually_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>
    </form>
</template>

<script>
import $ from 'jquery'
import {depositPfService, depositStarshopService} from "@/common/api.service"
import {KTApp} from '@/plugins/core/app';
import {i18n} from "@/plugins/i18n";
import toastr from "toastr";

export default {
    data() {
        return {
            new_access_ip: null,
            form_data: {},
            depositPfService,
            depositStarshopService
        }
    },
    mounted() {
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        submit() {
            let btn = $('#get_deposit_manually_btn');
            let form = $('#get_deposit_manually_form');

            form.validate({
                rules: {
                    from_date: {
                        required: true
                    },
                    to_date: {
                        required: true
                    },
                    bank: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                return
            }

            KTApp.progress(btn);

            this.apiService.getDepositManually(this.form_data).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn);
            })
        },
        clearFromDate() {
            if (this.form_data.from_date) {
                this.form_data.from_date = null
            }
        },
        clearToDate() {
            if (this.form_data.to_date) {
                this.form_data.to_date = null
            }
        },
    },
    computed: {
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>